import * as React from "react";

function SvgOverview(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 34 34" fill="none" {...props}>
      <path
        d="M17 0L8.5 4.25 17 8.5l8.5-4.25L17 0zM8.5 5.667l7.792 3.896v8.5L8.5 14.166v-8.5zM17.708 18.063l7.792-3.896v-8.5l-7.792 3.896v8.5z"
        fill="#fff"
      />
      <path
        d="M8.5 15.583L0 19.833l8.5 4.25 8.5-4.25 8.5 4.25 8.5-4.25-8.5-4.25-8.5 4.25-8.5-4.25zM0 21.25l7.792 3.896V34L0 29.75v-8.5z"
        fill="#fff"
      />
      <path
        d="M9.208 34L17 29.75 24.792 34v-8.854L17 21.25l-7.792 3.896V34zM34 29.75L26.208 34v-8.854L34 21.25v8.5z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgOverview;
